import { render, staticRenderFns } from "./DenunciaBlocoPesquisaFiltros.vue?vue&type=template&id=0c40bf3d&lang=pug"
import script from "./DenunciaBlocoPesquisaFiltros.vue?vue&type=script&lang=js"
export * from "./DenunciaBlocoPesquisaFiltros.vue?vue&type=script&lang=js"
import style0 from "./DenunciaBlocoPesquisaFiltros.vue?vue&type=style&index=0&id=0c40bf3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports